module.exports = __webpack_public_path__ + "img/Jobshark_light.b42c55f2.png";